<template lang="pug">
	.project-create(v-if="showed")
		.card
			.card-header
				span Create new project
			.card-body.collapse.show
				.form-horizontal
					button.btn.btn-warning(type="button" v-on:click="createFromTemplate()") Create playable from template
					button.btn.btn-warning(type="button" v-on:click="uploadCocosProject()") Create playable from Cocos Creator build
					button.btn.btn-primary(type="button" v-on:click="request()") Request custom playable ad development
					button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "ProjectCreatePlayable",
		mixins: [Screen],
		screen: {
			events: {
				"Show ProjectCreatePlayable": function() {

					this.showed = true;

				}
			}
		},
		data() {

			return {
				showed: false
			};

		},
		methods: {
			collectData() {


			},
			createFromTemplate() {

				Broadcast.call("Show ProjectCreatePlayableFromTemplate");

				this.hide();

			},
			uploadCocosProject() {

				Broadcast.call("Show ProjectCreatePlayableFromCocosCreator");

				this.hide();

			},
			request() {

				Broadcast.call("Show ProjectCreatePlayableRequest");

				this.hide();

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.project-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 450px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 300px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff
				margin-top: 20px
				width: 150px

			.btn-primary
				white-space: nowrap
				width: 300px
				margin-bottom: 10px

			.btn-warning
				white-space: nowrap
				width: 300px
				margin-bottom: 10px

			.form-horizontal
				display: flex
				flex-direction: column
				align-items: center

</style>

